import { setAttachmentIsInline } from '../actions/satchelV3Actions/publicActions';
import { mutator } from 'satcheljs';
import getAttachment from '../selectors/getAttachment';

mutator(setAttachmentIsInline, actionMessage => {
    const { attachmentId, isInline } = actionMessage;
    const attachment = getAttachment(attachmentId);
    attachment.model.IsInline = isInline;
});
